import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Home-products.css';

const CARD_DATA = [
    {
      title: "PAPER BAGS",
      description: "Eco-friendly kraft paper bags designed for durability and style, perfect for retail and gift packaging.",
      mainImage: '/assets/products-with-logo/paper-bags/paper-bags-small-size1.jpg',
      sideImage: '/assets/products-with-logo/paper-bags/paper-bags-large-size.jpg',
      path: '/paper-bags'
    },
    {
      title: "COURIER BAGS",
      description: "Durable and lightweight courier bags tailored for e-commerce businesses, ensuring customer satisfaction with secure packaging.",
      mainImage: '/assets/products-with-logo/courier-bags/courier-bags-small-size.png',
      sideImage: '/assets/products-with-logo/courier-bags/courier-bags-large-size.png',
      path: '/courier-bags'
    },
    {
      title: "PACKAGING PRODUCTS",
      description: "Green packaging products designed to protect the planet while meeting all your packaging requirements.",
      mainImage: '/assets/products-with-logo/packaging-products/packaging-products-small-size.png',
      sideImage: '/assets/products-with-logo/packaging-products/packaging-products-large-size.png',
      path: '/packaging-products'
    }
];

const PaperBagCard = ({ data }) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(data.path);
  };

  return (
    <div className="col-md-4 mb-4">
      <div 
        className="paper-bag-card"
        onClick={handleClick}
      >
        <div 
          className="paper-bag-image-container"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div className={`paper-bag-main-image ${isHovered ? 'opacity-0' : 'opacity-100'}`}>
            <img
              className="paper-bag-img"
              src={data.mainImage}
              alt={data.title}
            />
          </div>
          
          <div className={`paper-bag-hover-content ${isHovered ? 'opacity-100' : 'opacity-0'}`}>
            <div className="paper-bag-left-content">
              <img
                className="paper-bag-img"
                src={data.sideImage}
                alt={`${data.title} Side`}
              />
            </div>
            <div className="paper-bag-right-content">
              <p>{data.description}</p>
            </div>
          </div>
        </div>
        
        <div className="paper-bag-title-container">
          <h3>{data.title}</h3>
        </div>
      </div>
    </div>
  );
};

const HomeProducts = () => {
  return (
    <section className="products-section py-5">
      <div className="container-fluid p-4">
        <div className="text-center mb-5">
          <p className="product-sub-heading text-uppercase mb-2">OUR PRODUCTS LIST</p>
          {/* <h2 className="paper-bag-section-title">What We're Offering</h2> */}
        </div>
        <div className="row">
          {CARD_DATA.map((data, index) => (
            <PaperBagCard key={index} data={data} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeProducts;